/** GV-04 — Vue des colonnes disponibles, dans l'ordre canonique du CSV API. */
export interface RegistrationExportColumn {
  key: string;
  label: string;
}

export const REGISTRATION_EXPORT_STATIC_COLUMNS: readonly RegistrationExportColumn[] = [
  { key: 'team.name', label: 'Equipe' },
  { key: 'club.name', label: 'Club' },
  { key: 'team.registrationStatus', label: 'Statut inscription' },
  { key: 'team.paymentStatus', label: 'Statut paiement' },
  { key: 'payment.paidAmount', label: 'Montant paye (EUR)' },
  { key: 'payment.refundAmount', label: 'Montant rembourse (EUR)' },
  { key: 'payment.netAmount', label: 'Net paiement (EUR)' },
  { key: 'team.createdAt', label: 'Date inscription' },
  { key: 'captain.phone', label: 'Tel capitaine' },
  { key: 'captain.email', label: 'Email capitaine' },
];

const PLAYER_COLUMNS = [
  { suffix: 'licenseNumber', label: 'Licence' },
  { suffix: 'lastName', label: 'Nom' },
  { suffix: 'firstName', label: 'Prenom' },
  { suffix: 'licenseAutoDeclared', label: 'Auto-declaration licence' },
] as const;

/** null = brouillon sans configuration (0 joueur) ; undefined = payload indisponible. */
export function isRegistrationExportConfigAvailable(playersPerTeam: number | null | undefined): boolean {
  return (
    playersPerTeam === null ||
    (typeof playersPerTeam === 'number' && Number.isSafeInteger(playersPerTeam) && playersPerTeam >= 0)
  );
}

export function buildRegistrationExportColumns(playersPerTeam: number | null): RegistrationExportColumn[] {
  if (!isRegistrationExportConfigAvailable(playersPerTeam)) {
    throw new RangeError('Nombre de joueurs invalide pour la sélection des colonnes');
  }

  const columns: RegistrationExportColumn[] = [...REGISTRATION_EXPORT_STATIC_COLUMNS];
  for (let n = 1; n <= (playersPerTeam ?? 0); n += 1) {
    for (const { suffix, label } of PLAYER_COLUMNS) {
      columns.push({ key: `players.${n}.${suffix}`, label: `J${n} - ${label}` });
    }
  }
  return columns;
}
